import { render, staticRenderFns } from "./InstituteListDropdown.vue?vue&type=template&id=47470b10"
import script from "./InstituteListDropdown.vue?vue&type=script&lang=js"
export * from "./InstituteListDropdown.vue?vue&type=script&lang=js"
import style0 from "./InstituteListDropdown.vue?vue&type=style&index=0&id=47470b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports